import { Link, useNavigate } from "react-router-dom";
import Checkbox from "../../elements/Checkbox";
import styles from "./index.module.css";
import { useEffect, useState } from "react";
import { loginUser } from "../../../api/auth";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setSource } from "../../../store/slices/constants/constant.slice";
import { setOrganizationId } from "../../../store/slices/user/user.slice";
import { getSource } from "../../../utils/helpers";

const Login = (props) => {
  const [remember, setRemember] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("session_expired")) {
      sessionStorage.removeItem("session_expired");
      toast.error("Your session has expired. Please log in again.");
    }
  }, []);

  const onRememberChange = () => setRemember((state) => !state);

  const debounce = () => {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(onLogin, 200);
    };
  };
  const onLogin = (event) => {
    if (!loader) {
      let err = 0;

      if (user.length === 0) {
        err++;
        toast.error("Username is required!");
      }

      if (pass.length == 0) {
        err++;
        toast.error("Password is required!");
      } else if (pass.length < 8) {
        err++;
        toast.error("Password require atleast 8 characters!");
      }

      if (err === 0) {
        setLoader(true);
        loginUser(user, pass).then((res) => {
          setLoader(false);
          if (res.status === "success") {
            const { user_name, first_name, last_name, email, user_source, organisation_id } =
              res.data;
            localStorage.setItem("token", res.jwt);
            localStorage.setItem(
              "data",
              JSON.stringify({
                user_name,
                first_name,
                last_name,
                email,
                user_source,
                organisation_id,
              })
            );
            toast.success("Logged in successfully!");
            dispatch(setSource(user_source[0]));
            dispatch(setOrganizationId(organisation_id));
            if (user_source[0] === "aelia_auckland" && organisation_id !== 3) {
              navigate("/dashboard/fnb-dashboard");
            } else {
              navigate("/dashboard/df-dashboard");
            }
          } else if (res.status == "fail") {
            toast.error(res.message);
          }
        });
      }
    }
  };

  const onUserChange = (e) => {
    setUser(e.target.value);
  };
  const onPassChange = (e) => {
    setPass(e.target.value);
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["left"]}>
        <div className={styles["card"]}>
          <div className={styles["top"]}>
            <img src={"./new_green_logo.png"} alt="priceport green logo" />
          </div>
          <div className={styles["bottom"]}>
            <div className={styles["content"]}>
              <div className={styles["text"]}>Hi, Welcome Back</div>
              <div className={styles["illustration"]}>
                <img
                  src={"./illustration_login.png"}
                  alt="illustration of girl walking with system"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["right"]}>
        <div className={styles["form"]}>
          <div className={styles["text"]}>
            <div className={styles["main"]}>Log In</div>
            <div className={styles["sub"]}>
              <i class="bi bi-lock-fill"></i> Your passwords are encrypted
            </div>
          </div>
          <div className={styles["inputs"]}>
            <div className={styles["input_box"]}>
              <div className={styles["label"]}>Username</div>
              <div className={styles["input"]}>
                <input
                  type="text"
                  placeholder="Username"
                  value={user}
                  onChange={onUserChange}
                />
              </div>
            </div>
            <div className={styles["input_box"]}>
              <div className={styles["label"]}>Password</div>
              <div className={styles["input"] + " " + styles["pass"]}>
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="password"
                  value={pass}
                  onChange={onPassChange}
                />
                {showPass ? (
                  <i
                    className="bi bi-eye"
                    onClick={() => setShowPass(false)}
                  ></i>
                ) : (
                  <i
                    className="bi bi-eye-slash"
                    onClick={() => setShowPass(true)}
                  ></i>
                )}
              </div>
            </div>
          </div>
          <div className={styles["submission"]}>
            <div className={styles["other_ctas"]}>
              <div className={styles["remember"]}>
                <div className={styles["checkbox"]}>
                  <Checkbox
                    state={remember}
                    size={"calc(2.5 * var(--base-x))"}
                    borderRadius={"4px"}
                    onClick={onRememberChange}
                  />
                </div>
                <div>Remember me</div>
              </div>
              <div className={styles["forgot"]}>
                <Link to={"/forgot"}>Forgot Password?</Link>
              </div>
            </div>
            <div className={styles["main_cta"]}>
              <div className={styles["button"]} onClick={debounce()}>
                Login
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
